export const EMAIL_VERIFICATION_POLL_INTERVAL_MS = 10_000
